import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";

/**
 * a little function to help us with reordering the result
 * @param {*} list 
 * @param {*} targetKeys
 * @param {*} startIndex 
 * @param {*} endIndex 
 */
var reorder = function reorder(list, targetKeys, startIndex, endIndex) {
  var result1 = Array.from(list);

  var _result1$splice = result1.splice(startIndex, 1),
      _result1$splice2 = _slicedToArray(_result1$splice, 1),
      removed1 = _result1$splice2[0];

  result1.splice(endIndex, 0, removed1);
  var result2 = Array.from(targetKeys);

  var _result2$splice = result2.splice(startIndex, 1),
      _result2$splice2 = _slicedToArray(_result2$splice, 1),
      removed2 = _result2$splice2[0];

  result2.splice(endIndex, 0, removed2);
  var result = {};
  result.dataArr = result1;
  result.targetKeyArr = result2;
  return result;
};
/**
 * Moves an item from one list to another list.
 * @param {*} source 
 * @param {*} destination 
 * @param {*} droppableSource 
 * @param {*} droppableDestination 
 * @param {*} targetKeys
 */


var move = function move(source, destination, droppableSource, droppableDestination, targetKeys) {
  var sourceClone = Array.from(source);
  var destClone = Array.from(destination);

  var _sourceClone$splice = sourceClone.splice(droppableSource.index, 1),
      _sourceClone$splice2 = _slicedToArray(_sourceClone$splice, 1),
      removed = _sourceClone$splice2[0];

  destClone.splice(droppableDestination.index, 0, removed);
  targetKeys.splice(droppableDestination.index, 0, removed.key);
  var result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;
  result.newTargetKeys = targetKeys;
  return result;
};

export { reorder, move };


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-transfer/src/utils.js